import React, { useState } from 'react';

import OurStylistData from './Data/OurStylistArizonaData';
import GalleryData from './Data/GalleryArizonaData';
import ColorPallet from '../../../../../../../utils/ColorPallet';

import BookingButton from '../../../../Location/components/BookingButton';

function SecondSection() {
 const tabs = [
  { id: 'about', label: 'About' },
  { id: 'stylists', label: 'Our Stylists' },
  { id: 'gallery', label: 'Gallery' },
  { id: 'location', label: 'Location' }
];

  const [activeTab, setActiveTab] = useState('about');
  const [selectedLocation, setSelectedLocation] = useState('Jakarta');
  const locations = Object.keys(GalleryData);
 
  return (
    <div className="min-h-screen p-4 md:p-8">
      <div className="max-w-6xl mx-auto mb-8">

        {/* Navigation Tabs */}
        <div className="flex gap-4 mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`px-4 py-2 transition-colors duration-300 ${
                activeTab === tab.id
                  ? 'text-orange-900 border-b-2 font-bold border-orange-900'
                  : ColorPallet.primaryDarkBrown
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content About */}
        <div className="mb-8">
          {activeTab === 'about' && (
            <div className="backdrop-blur-sm border border-slate-700 rounded-lg p-6" style={{ backgroundColor: ColorPallet.secondLightBrown }}>
              <h2 className="text-xl font-bold mb-4" style={{ color: ColorPallet.primaryDarkBrown }}>About Us</h2>
              <p className="text-white space-y-6">
                <span className="block mb-6">
                  Welcome to Papakilo Arizona
                </span>

                <span className="block mb-6">
                  Our philosophy is rooted in the concept of harmony that celebrates the balance between desert beauty and modern elegance. At Papakilo Arizona, we interpret beauty through three fundamental pillars:
                </span>

                <span className="block mb-6">
                  <strong>Natural Authenticity</strong>
                  <br />
                  We believe that true beauty lies in embracing your authentic self. Each cut and style we create celebrates your natural uniqueness, rather than drastically changing it. Like the desert landscape that evolves with patience and time, we help discover and enhance your natural essence.
                </span>

                <span className="block mb-6">
                  <strong>Continuous Growth</strong>
                  <br />
                  Every client we serve is a commitment to continuous learning and development. Our team doesn't just follow trends, but understands that excellence is an ongoing journey, always seeking innovative ways to deliver the best experience for each guest.
                </span>

                <span className="block mb-6">
                  <strong>Heartfelt Hospitality</strong>
                  <br />
                  Beyond excellent service, we embrace genuine hospitality - the art of serving sincerely with warmth and intention. Every technique, every conversation, is based on a deep commitment to your comfort and satisfaction.
                </span>

                <span className="block mb-6">
                  At Papakilo Arizona, we don't just create hairstyles - we invite you on a journey to discover harmony between your inner spirit and outer appearance, between timeless style and contemporary trends, between who you are today and the vibrant potential within you.
                </span>

                <span className="block">
                  We exist to help you express your authentic self through a look that reflects your true essence and elevates your natural beauty.
                </span>
              </p>
            </div>
          )}

          {/* Tab Content Stylist */}
        {activeTab === 'stylists' && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {OurStylistData.map((stylist, index) => (
                <div 
                  key={index} 
                  className="bg-white/10 border border-slate-700 rounded-lg p-6 text-center 
                  hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:scale-110 group transition-transform duration-300">
                  {/* Stylist Avatar */}
                  <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-[#efcdbe] group-hover:bg-white flex items-center justify-center">
                    <img 
                      src={stylist.image} 
                      alt={stylist.name} 
                      className="w-full h-full object-contain rounded-full" 
                    />
                  </div>

                  {/* Stylist Information */}
                  <h3 className="text-lg font-semibold mb-2 group-hover:text-white">{stylist.name}</h3>
                  <p className="text-slate-600 mb-1 group-hover:text-white/80">{stylist.specialty}</p>
                  <p className="text-sm text-slate-800 group-hover:text-white/70">Experience: {stylist.experience}</p>
                </div>
              ))}
            </div>
          )}

          {/* Tab Content Gallery */}
          {activeTab === 'gallery' && (
            <div className="backdrop-blur-sm border border-slate-700 rounded-lg p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-bold" style={{ color: '#4A3427' }}>Gallery Arizona</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {GalleryData.map((item, index) => (
                  <div 
                    key={index} 
                    className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    <img 
                      src={item.image}
                      alt={item.title}
                      className="w-full h-60 object-cover rounded-lg transition-transform duration-300 group-hover:scale-105"
                    />
                    {/* <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                      <h3 className="font-semibold text-lg mb-1">{item.title}</h3>
                      <p className="text-sm text-gray-200">{item.category}</p>
                    </div> */}
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'location' && (
            <div className="backdrop-blur-sm border border-slate-700 rounded-lg p-6 bg-white">
              <h2 className="text-xl font-bold mb-0" style={{ color: ColorPallet.primaryDarkBrown }}>Our Locations</h2>
              
              {/* Location Selector */}
              <div className="flex flex-wrap gap-2 mb-6">
                {locations.map((loc) => (
                  <button
                    key={loc}
                    className={`px-4 py-0 rounded-lg transition-colors duration-300 ${
                      selectedLocation === loc
                        ? 'bg-orange-900 text-white'
                        : 'bg-white/20 text-white hover:bg-white/30'
                    }`}
                    onClick={() => setSelectedLocation(loc)}
                  >
                    {loc}
                  </button>
                ))}
              </div>

              {/* Location Details */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Map */}
                <div className="rounded-lg overflow-hidden h-full border border-slate-600">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d311.39129771781!2d98.69693684766463!3d3.6302946914749104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3031330079533051%3A0x885be5fad828d5af!2sPapakilo%20Barbershop%20(cemara%20asri)!5e0!3m2!1sid!2sid!4v1740715395912!5m2!1sid!2sid"
                    className="w-full h-full object-cover"
                    referrerPolicy="no-referrer-when-downgrade" 
                  ></iframe>
                </div>

                {/* Contact Information */}
                <div className="text-slate-800 space-y-6">
                  <div>
                    <h3 className="text-lg font-semibold mb-2">Papakilo Medan (Landed In Arizona)</h3>
                    <p className="text-slate-400">
                      Jl. Cemara Asri Boulevard Raya No.A14, Medan Estate, <br/>Kec. Percut Sei Tuan, Kota Medan, Sumatera Utara 20371
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold mb-2">Opening Hours</h3>
                    <div className="grid grid-cols-2 text-slate-400">
                      <div>
                        <p>Senin - Minggu :</p>
                      </div>
                      <div>
                        <p>10:00 - 22:00</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold mb-2">Contact</h3>
                    <p className="text-slate-400">Phone : +62 878 1634 4463</p>
                    <p className="text-slate-400">Email : papakilobarbershop@gmail.com</p>
                    <p className="text-slate-400">Instagram : @papakilomedan.arizona</p>
                  </div>

                  <div className="pt-4">
                    <div className="p-4 bg-gradient-to-r from-purple-600 to-blue-500 w-60 rounded-full">
                    <BookingButton />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SecondSection